export enum ConditionalKeys {
    People = 'people',
    PersonCompany = 'personCompany',
    PersonCraft = 'personCrafts',
    PersonSites = 'personSites',
    PersonTags = 'personTags',
}

export const DEFAULT_KEYS = [
    ConditionalKeys.People,
    ConditionalKeys.PersonCompany,
    ConditionalKeys.PersonCraft,
    ConditionalKeys.PersonTags,
];

export interface SimplePersonCondition {
    key?: ConditionalKeys;
    value?: string[];
    negate?: boolean;
    self?: boolean;
}

export interface ComplexPersonCondition {
    conditions: PersonCondition[];
    type: 'or' | 'and';
}

export type PersonCondition = ComplexPersonCondition | SimplePersonCondition;

// simplified interface required for person matching
export interface PersonLike {
    id?: string;
    folderId?: string;
    userId?: string;
    group?: string | boolean;
    crafts?: string[];
    tags?: string[];
    companyId?: string;
    supportAccess?: string;
    fullName?: string;

    // automatic facility matching if you do not pass in a facility predicate
    facilityIds?: string[];
    facilities?: Record<string, any>;
}

export interface PersonMatcher {
    facilityIds?: string[];
    excludedFacilityIds?: string[];
    conditions?: ComplexPersonCondition;
}

export type PersonFacilityPredicate = (facilityId: string, person?: PersonLike) => boolean;

/**
 * Used to populate the dropdown for simple conditions.
 */
export const SIMPLE_CONDITION_OPTIONS = [
    { key: ConditionalKeys.People, negate: false },
    { key: ConditionalKeys.PersonTags, negate: false },
    { key: ConditionalKeys.PersonCraft, negate: false },
    { key: ConditionalKeys.PersonCompany, negate: false },
    { key: ConditionalKeys.People, negate: true },
    { key: ConditionalKeys.PersonTags, negate: true },
    { key: ConditionalKeys.PersonCraft, negate: true },
    { key: ConditionalKeys.PersonCompany, negate: true },
    { key: ConditionalKeys.PersonSites, negate: false },
    { key: ConditionalKeys.PersonSites, negate: true },
];
